import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { object } from "yup";
import { buildQuestionsMap, defaultDeliveryQuestionsAnswer } from "../../Addresses/addressesUtils";
import { addressFormSchema, buildDeliveryInputSchema } from "./utils/addressFormSchema";
/**
 * In addition to the other logic for the add/update address form, we encapsulate the RHF methods here as well.
 * This allows us to use the same form for both the add/update address modal and the update delivery modal, which
 * rely on two different form components. One for context modals, one for non-context modals.
 * @param deliveryQuestions
 * @param currentCardAddress
 * @returns
 */
export const useAddUpdateAddressForm = (deliveryQuestions, currentCardAddress) => {
    var _a, _b;
    // If the address has delivery answers, we pull from that information for question and answer consistency,
    // otherwise we use the delivery questions config.
    const deliveryQuestionsMap = buildQuestionsMap(deliveryQuestions);
    // Static form fields default values.
    const staticDefaultValues = {
        addressId: !!currentCardAddress ? currentCardAddress.addressId : 0,
        firstName: !!currentCardAddress ? currentCardAddress.firstName : "",
        lastName: !!currentCardAddress ? currentCardAddress.lastName : "",
        address1: !!currentCardAddress ? currentCardAddress.address1 : "",
        address2: !!currentCardAddress ? (_a = currentCardAddress.address2) !== null && _a !== void 0 ? _a : "" : "",
        city: !!currentCardAddress ? currentCardAddress.city : "",
        state: !!currentCardAddress ? currentCardAddress.state : "",
        country: !!currentCardAddress ? currentCardAddress.country : "",
        zip: !!currentCardAddress ? currentCardAddress.zip : "",
        route_code: !!currentCardAddress ? (_b = currentCardAddress.route_code) !== null && _b !== void 0 ? _b : "" : "",
        isPrimary: !!currentCardAddress ? currentCardAddress.isPrimary : false,
    };
    // Dynamic form fields default values (delivery questions/answers).
    const questionFields = defaultDeliveryQuestionsAnswer(deliveryQuestionsMap, currentCardAddress);
    // Combined static & dynamic form fields and default values.
    const defaultFormValues = Object.assign(Object.assign({}, staticDefaultValues), questionFields);
    const reactHookFormMethods = useForm({
        defaultValues: defaultFormValues,
        mode: "onSubmit",
        resolver: yupResolver(object(Object.assign(Object.assign({}, addressFormSchema), buildDeliveryInputSchema(deliveryQuestionsMap)))),
        shouldUseNativeValidation: false,
        reValidateMode: "onChange",
        shouldFocusError: true,
    });
    return {
        staticDefaultValues,
        questionFields,
        defaultFormValues,
        reactHookFormMethods,
        deliveryQuestionsMap,
    };
};
